//Reference: EN089 (Modified) 

/*  
    Added a new field 'ID_SUB_ROLES' which doesn't belong to the original EN089.
    The reason is to replicate an optimized backend that will return this fields whose value will 
    contain an array of objects from EN076. This relationship EN089 & EN076 belongs to EN077.
*/

import { Mappeable } from './mappeable.model';
import { RoleType } from './role-type.model';
import * as _ from 'lodash';
import moment from 'moment';

export class User extends Mappeable {

    idUserPk: number;
    cdNuuma: string;
    txtName: string;
    txtLastname1: string;
    txtLastname2: string;
    txtFullname: string;
    fullName: string;
    isActive: boolean;
    txtMail: string;
    nmrMobile: number;
    entamap: any;
    typeRole: RoleType;
    mrkActive: boolean;
    organizationalStructure: any;
    language: any;
    dateAdmission: any;
    workLeaveDate: any;
    roles: any;
    professionalCategoryTypes: any;
    secondaryRoles: []
    mobilityFunctional: boolean;
    mobilityGeographic: boolean;
    nmrLaboralHours: number;
    typeTreatment: string;
    txtComment: string;
    filePhotoName: String;
    fileFirmName: String;
    fileCvEsName: String;
    fileCvEnName: String;

    constructor(o) {
        super(o)
        this.professionalCategoryTypes = _.isUndefined(this.professionalCategoryTypes) || _.isNull(this.professionalCategoryTypes) ? null : [this.professionalCategoryTypes];
        this.mrkActive = _.isUndefined(this.mrkActive) || _.isNull(this.mrkActive) ? false : this.mrkActive;
        this.mobilityFunctional = _.isUndefined(this.mobilityFunctional) || _.isNull(this.mobilityFunctional) ? false : this.mobilityFunctional;
        this.mobilityGeographic = _.isUndefined(this.mobilityGeographic) || _.isNull(this.mobilityGeographic) ? false : this.mobilityGeographic;
        this.txtFullname = `${this.txtName || ""} ${this.txtLastname1 || ""} ${this.txtLastname2 || ""}`;
        this.fullName = this.txtFullname;
    }

    mapToBackAdminUser() {
        return {
            cdNuuma: this.cdNuuma,
            txtName: this.txtName,
            txtLastname1: this.txtLastname1,
            txtLastname2: this.txtLastname2,
            mrkActive: this.mrkActive,
            // Tratamiento
            txtMail: this.txtMail,
            language: this.language,
            entamap: this.entamap,
            nmrMobile: this.nmrMobile,
            //dateAdmission: this.dateAdmission,
            workLeaveDate: moment(this.workLeaveDate).format("YYYY-MM-DD"),
            txtComment: this.txtComment,
            // Recibir correos
            filePhotoName: this.filePhotoName,
            fileFirmName: this.fileFirmName,
            fileCvEsName: this.fileCvEsName,
            fileCvEnName: this.fileCvEnName,
            roles: this.roles,
            organizationalStructure: this.organizationalStructure,
            // Estructuras organizativas adicionales
            professionalCategoryTypes: this.professionalCategoryTypes,
            mobilityFunctional: this.mobilityFunctional,
            mobilityGeographic: this.mobilityGeographic,
            nmrLaboralHours: this.nmrLaboralHours,
            typeTreatment: this.typeTreatment
        }
    }
}